<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2025-03-17 14:21:37
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2025-04-01 18:20:18
 * @FilePath: \qctsw-vue\packages\app\src\components\layout\LayoutLoginWx.client.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script lang='ts' setup>
withDefaults(defineProps<{
  redirectUrl: string
}>(), {})
const showModal = ref(false)

function init() {
  showModal.value = true
}
const { showLoginPopup } = useLoginPopupEvent()
defineExpose({ init })
</script>

<template>
  <n-modal v-model:show="showModal" mask-closable>
    <n-card size="huge" :bordered="false" role="dialog" aria-modal="true" style="--n-padding-left: 0" class="w-80 rounded-md">
      <iframe
        class="w-80 h-100"
        :src="redirectUrl"
      />
      <div class="text-right mr-4 cursor-pointer" @click="showLoginPopup('phone'), showModal = false">
        手机号登录
      </div>
    </n-card>
  </n-modal>
</template>

<style lang='scss' scoped>
:deep(.n-card){
  .n-card__content, .n-card__footer{
    padding: 0;
  }
}
</style>
